import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {Constant} from 'projects/Autofacets-Core/src/app/utils/constant';
import {BehaviorSubject} from 'rxjs';
import {DMSSyncFailedlogService} from '../../business-services/dms-sync-failed-log.service';
import {DatePipe} from "@angular/common";
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import {SortEvent} from "../../../../../Autofacets-Core/src/app/directives/sortable.directive";
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { AfxexceptionComponent } from '../afxexception/afxexception.component';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-afx-syncfailedlog',
  templateUrl: './afx-syncfailedlog.component.html',
})
export class AfxSyncfailedlogComponent implements OnInit {
  bookingDate: any[] = [];
  afxLogList: any = [];
  featureList: any[];
  total$ = new BehaviorSubject<number>(0);
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  isTodayViewOn: boolean = true;
  todayDate = new Date();
  afxLogRequestModel: any = {};
  popupCloseResult = false;

  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;

  constructor(
    public service: DMSSyncFailedlogService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.afxLogRequestModel = {
      LogFromDate: this.todayDate,
      LogToDate: this.todayDate,
      StartRecordNumber: 0,
      PageSize: 25,
      SortColumn: 'endtime',
      sortDirection: 'DESC',
      Module: ''
    };
    this.bookingDate=[];
    this.bookingDate.push(this.todayDate);
    this.bookingDate.push(this.todayDate);
    if (this.service.filterTypeId == 1) {
      this.loadTodayView();
    } else if (this.service.filterTypeId == 2) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
    this.GetModuleNamesList();
  }
  GetModuleNamesList(){
    this.service.GetModuleNamesList().then((response: any) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.featureList = [];
        this.featureList = response.responseObject;
  }
})}

  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  onSort({column, direction}: SortEvent) {
    this.afxLogRequestModel.SortColumn = column;
    this.afxLogRequestModel.IsAscending = direction === 'asc';
    this.afxLogRequestModel.StartRecordNo = 0;
    this.afxLogList = []
    this.GetAFXLogList(this.afxLogRequestModel);
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.todayDate = new Date();
    this.bookingDate=[];
    this.bookingDate.push(this.todayDate);
    this.bookingDate.push(this.todayDate);
    this.afxLogRequestModel.LogFromDate = this.todayDate;
    this.afxLogRequestModel.LogToDate = this.todayDate;
    this.afxLogRequestModel.StartRecordNo = 0;
    this.afxLogList = []
    this.GetAFXLogList(this.afxLogRequestModel);
  }

  loadWeekView() {
    this.isTodayViewOn = false;

    let current = new Date();
    const startDay = 1; //0=sunday, 1=monday etc.
    const d = current.getDay(); //get the current day
    const weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000); //rewind to start day
    const weekEnd = new Date(weekStart.valueOf() + 6 * 86400000); //add 6 days to get last day
    //this.weekViewDate = this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
    this.afxLogRequestModel.LogFromDate = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 1);
    this.afxLogRequestModel.LogToDate = new Date(weekEnd.getFullYear(), weekEnd.getMonth(), weekEnd.getDate() + 1);
    this.bookingDate=[];
    this.bookingDate.push(weekStart);
    this.bookingDate.push(weekEnd);
    this.afxLogRequestModel.StartRecordNo = 0;
    this.afxLogList = []
    this.GetAFXLogList(this.afxLogRequestModel);
  }

  onDateRangeChanged(event: any) {
      this.afxLogRequestModel.LogFromDate = '';
      this.afxLogRequestModel.LogToDate = '';
      if(typeof event !== 'undefined'){
        const startDate = new Date(event[0]);
        this.afxLogRequestModel.LogFromDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString();
      }
      if(typeof event !== 'undefined'){
        const endDate = new Date(event[1]);
        this.afxLogRequestModel.LogToDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1).toISOString();
      }
      this.afxLogRequestModel.StartRecordNo = 0;
      this.afxLogList = []
      this.GetAFXLogList(this.afxLogRequestModel);
  }

  refresh() {
    this.afxLogRequestModel.LogFromDate = this.todayDate;
    this.afxLogRequestModel.LogToDate = this.todayDate;
    this.bookingDate=[];
    this.bookingDate.push(this.todayDate);
    this.bookingDate.push(this.todayDate);
    this.afxLogRequestModel.StartRecordNo = 0;
    this.afxLogList = []
    this.GetAFXLogList(this.afxLogRequestModel);
  }

  viewException(result) {
    let modelHeadermsg = this.translate.instant("lblSyncErrorLog");
    const modalRef = this.modalService.open(AfxexceptionComponent, {size: 'lg'});
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.dmsLogList = result;
    modalRef.result.then((_result) => {
       // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
    });
  }

  onFeatureSelect(modueId: string) {
    this.afxLogRequestModel.Module = modueId ? modueId : '';
    this.afxLogRequestModel.StartRecordNo = 0;
    this.afxLogList = []
    this.GetAFXLogList(this.afxLogRequestModel)
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.afxLogList.length){
      this.afxLogRequestModel.startRecordNumber = this.afxLogList.length
      this.GetAFXLogList(this.afxLogRequestModel);
    }
  }

  GetAFXLogList(dmsLogRequestModel) {
    this.spinner.show();
    this.service.GetAfxSyncFailedLog(dmsLogRequestModel).then((response: any) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        response.responseObject.forEach(element => {
          element.startDate = element.startDate ? new Date(element.startDate + 'Z') : null;
          element.endDate = element.endDate ? new Date(element.endDate + 'Z') : null;
        });
        this.afxLogList.push(...response.responseObject);
        this.totalCount = this.afxLogList.length > 0 ? this.afxLogList[0].totalCount : 0
        this.spinner.hide();
      } else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
